import React, {useEffect, useRef, useState} from "react";

let modalRequest;
const loadModal = () => {
    if (!modalRequest) {
        modalRequest = import("./Modal/Modal").catch(error => {
            modalRequest = null;
            throw error;
        });
    }
    return modalRequest;
};

const DeferredModal = ({isOpened = false, onClose, ...props}) => {
    const [Modal, setModal] = useState(null);
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        if (!isOpened || Modal) return;

        let cancelled = false;
        const handleKeyDown = event => {
            if (event.key === "Escape") onCloseRef.current?.();
        };
        window.addEventListener("keydown", handleKeyDown);
        loadModal()
            .then(({default: Component}) => {
                if (!cancelled) setModal(() => Component);
            })
            .catch(error => {
                if (!cancelled) {
                    console.error("Failed to load modal", error);
                    onCloseRef.current?.();
                }
            });

        return () => {
            cancelled = true;
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpened, Modal]);

    // Keep the loaded modal mounted on close so its exit animation can finish.
    return Modal ? <Modal {...props} isOpened={isOpened} onClose={onClose} /> : null;
};

export default DeferredModal;
